// File: config.navbar.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration used by cgp-nav-bar.
// Other Contributors:

import { baseConfig } from './config.base';

// Nav Bar Items

const camtl = {
    id: 'MESC/CAMTL',
    title: 'CAMTL',
    iconClass: 'fa fa-fw fa-line-chart',
    expanded: true,
    children: [
        {
            id: 'MESC/CAMTL/MasterToolList',
            title: 'Master Tool List',
            iconClass: 'fa fa-fw',
        },
        {
            id: 'MESC/CAMTL/TimingCharts',
            title: 'Timing Charts',
            iconClass: 'fa fa-fw',
        },
        {
            id: 'MESC/CAMTL/Contacts',
            title: 'Contacts',
            iconClass: 'fa fa-fw',
        },
        {
            id: 'MESC/CAMTL/Administration',
            title: 'Administration',
            iconClass: 'fa fa-fw',

            children: [
                {
                    id: 'MESC/CAMTL/Administration/Maintenance',
                    title: 'Maintenance',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'MESC/CAMTL/Administration/Security',
                    title: 'Security',
                    iconClass: 'fa fa-fw',
                },
            ]
        },
        
        {
            id: 'MESC/CAMTL/WorkflowInbox',
            title: 'Workflow Inbox',
            iconClass: 'fa fa-fw',
        },
    ]
}

const tnts = {
    id: 'MESC/TNTS',
    title: 'TNTS',
    iconClass: 'fa fa-fw fa-pie-chart',
    expanded: true,
    children: [
        {
            id: 'MESC/TNTS/Tools',
            title: 'Tools',
            iconClass: 'fa fa-fw',
        },
        {
            id: 'MESC/TNTS/Administration',
            title: 'Administration',
            iconClass: 'fa fa-fw',

            children: [
                {
                    id: 'MESC/TNTS/Administration/ToolIdentificationMatrix',
                    title: 'Tool Identification Matrix',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'MESC/TNTS/Administration/TeamCenterLink',
                    title: 'Tool Team Center Link',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'MESC/TNTS/Administration/TransferTools',
                    title: 'Manage Transfer Tools',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'MESC/TNTS/Administration/Toolownership',
                    title: 'Transfer Tool Ownership',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'MESC/TNTS/Administration/ArchiveTools',
                    title: 'Archived Tools',
                    iconClass: 'fa fa-fw',
                },
            ]
        },
    ]
}

const mesc = {
    id: 'MESC',
    title: 'MESC',
    iconClass: 'fa fa-fw fa-superpowers',
    expanded: true,
    children: [
        {
            id: 'MESC/Administration',
            title: 'Administration',
            iconClass: 'fa fa-fw',
            children: [
                {
                    id: 'MESC/Administration/Maintenance',
                    title: 'Maintenance',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'MESC/Administration/Security',
                    title: 'Security',
                    iconClass: 'fa fa-fw',
                },
            ]
        },
        camtl,
        tnts,
    ]
}

export const navItems = [mesc];



// Nav Bar Actions
//
export const navActions = {};